const appointmentsOffer = [
  'Fertility assessments and preconception consultation',
  'Egg, sperm and embryo freezing',
  'Fertility treatments including IVF',
  'Family building options including donor egg, donor sperm, donor embryo, and surrogacy',
  'Wellness coaching to support your fertility journey'
];

export const componentDescription =
  'We provide a complete suite of reproductive clinical care & coaching:';

export function getAppointmentsOfferString(): string {
  return appointmentsOffer.join('\n');
}

export const EXCLUDED_PARTNER_CLINIC_EMPLOYERS = [
  'BenefitBump',
  'Bennie',
  'Beyond Med',
  'Caliber Schools',
  'Electric AI',
  'First Due',
  'FreeWill',
  'Heartland Forward, Inc.',
  'Justworks',
  'Kindbody',
  'Koch Industries (via Pomelo Care)',
  'Noom',
  'PKD Free-Babies Alliance',
  'RLTY Blue',
  'Sana Health',
  'Sendoso',
  'ShareCare',
  'Walmart',
  'Walmart Puerto Rico',
  'Walton Enterprises, Inc.'
];
